import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

const UserApp = () => {
    const navigate = useNavigate()
    useEffect(() => {
        navigate('/user-app/download')
    }, []);

    return (
        <></>
    )
}

export default UserApp